module.exports = __webpack_public_path__ + "static/media/paraguay.2e579981.svg";